var React = require('react');

function Restart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.01431 0.816406V1.59815C6.84983 1.59815 8.34325 3.09638 8.34325 4.93807C8.34325 6.77977 6.84983 8.278 5.015 8.278C3.17948 8.278 1.68607 6.78046 1.68607 4.93807C1.68607 4.25319 1.89352 3.59304 2.27684 3.03799L3.0208 3.78332L3.80392 0.848006L0.878906 1.63387L1.71973 2.47744C1.19083 3.18873 0.905583 4.0517 0.906384 4.93807C0.906384 7.21117 2.74946 9.05974 5.01431 9.05974C7.27986 9.05974 9.12224 7.21117 9.12224 4.93807C9.12224 2.66566 7.27986 0.816406 5.01431 0.816406Z","fill":"white","stroke":"white","strokeWidth":"0.3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Restart.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Restart;

Restart.default = Restart;
